var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircles = function SvgCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "aa",
    cx: 48.645,
    cy: 48.645,
    r: 48.645
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cc",
    cx: 58,
    cy: 58,
    r: 58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ee",
    cx: 38.667,
    cy: 38.667,
    r: 38.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    transform: "translate(9.355 9.355)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.355-8.731h117.871v117.87H-9.354z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dd"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cc"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cc"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.66-10.032h140.455v140.454H-10.66z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.333 19.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ee"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ee"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ff)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.108-7.484H85.44v93.548H-8.108z"
  }))))));
};
export default SvgCircles;